module.exports = __webpack_public_path__ + "static/GlobalSettings2-fc243339e04fbc015532b841de611b5f.png";